module.exports = __webpack_public_path__ + "img/cod-cold-war.7e638e67.png";